import { bootstrapConstants } from "./Constants";

let measurementCategory = JSON.parse(
  localStorage.getItem("measurementCategory")
);
measurementCategory = measurementCategory ? measurementCategory : {};
let measurementMagnitude = JSON.parse(
  localStorage.getItem("measurementMagnitude")
);
measurementMagnitude = measurementMagnitude ? measurementMagnitude : {};

let measurementType = JSON.parse(localStorage.getItem("measurementType"));
measurementType = measurementType ? measurementType : {};

export function measurements(
  state = { measurementCategory, measurementType, measurementMagnitude },
  action
) {
  switch (action.type) {
    case bootstrapConstants.MEASUREMENTS_REQUEST:
      return {
        measurements: action.payload
      };
    case bootstrapConstants.MEASUREMENTS_SUCCESS:
      return {
        measurements: {
          measurementCategory: action.measurements[0],
          measurementType: action.measurements[1],
          measurementMagnitude: action.measurements[2]
        }
      };
    case bootstrapConstants.MEASUREMENTS_FAILURE:
      return {
        measurements: []
      };
    default:
      return state;
  }
}
